<template>
  <b-container fluid class="milestones-container text-center">
    <h3 class="font-weight-bold">Create a new campaign</h3>
    <div class="w-75 d-flex align-items-center justify-content-between mt-4 mx-auto">
      <div v-for="(milestone, index) in create_milestones" :key="`create-milestone-${index}`"
        :class="['create-milestones d-inline-flex align-items-center justify-content-center position-relative', `-${milestone}`, { 'flex-shrink-0': milestone, '-in-between': !milestone, '-active': campaignData.active === milestone, '-done-milestone': currentStep > campaignData.milestones[milestone], '-in-between-done': currentStep > index || currentStep > 2 && currentStep == index }]">
        <template v-if="milestone === 'details'">
          <Details :isActive="campaignData.active === milestone" :isDone="currentStep > 1" />
        </template>
        <template v-else-if="milestone === 'execution'">
          <Execution :isActive="campaignData.active === milestone" :isDone="currentStep > 2" />
        </template>
        <template v-else-if="milestone === 'design'">
          <Design :isActive="campaignData.active === milestone" />
        </template>
        <span class="text-capitalize milestone-label font-weight-bold position-absolute">{{ milestone }}</span>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Details from './create-milestones/Details.vue';
import Execution from './create-milestones/Execution.vue';
import Design from './create-milestones/Design.vue';

export default {
  components: { Details, Execution, Design },
  computed: {
    ...mapState("punchCard", ["campaignData"]),
    ...mapGetters("punchCard", ["currentStep"])
  },
  data() {
    return {
      create_milestones: [
        "details",
        "",
        "execution",
        "",
        "design"
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.milestones-container {
  max-width: 720px;

  h3 {
    font-size: 24px;
    color: #2F3941;
  }

  .create-milestones {
    &:not(.-in-between) {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      border: solid 1px #D8DCDE;
    }

    &.-in-between {
      width: 100%;
      height: 1px;
      background-color: #D8DCDE;

      &.-in-between-done {
        background-color: rgba(255, 107, 0, 0.5);
      }
    }

    &.-active {
      background-color: #FF6B00;
      border-color: #FF6B00;
      border: 8px double white;
      width: 61px;
      height: 61px;

      .milestone-label {
        color: #FF6B00;
      }
    }

    &.-done-milestone {
      border-color: rgba(255, 107, 0, 0.5);

      .milestone-label {
        color: rgba(255, 107, 0, 0.5);
      }
    }

    .milestone-label {
      bottom: -45px;
      color: #C2C8CC;
      font-weight: normal !important;
    }
  }
}
</style>
